import { Component, OnInit, Inject } from '@angular/core';
import {
    MdInputModule, MdCheckboxModule, MdDialog, MdDialogRef,
    MD_DIALOG_DATA, MdAutocomplete, MdOptionSelectionChange
} from '@angular/material';
import { Utility } from '../../../common/utility';

import { DialogService } from '../../../shared/services/dialog.service';
import { BaseService } from '../../../shared/services/base.service';
import { ValidationService } from '../../../shared/services/validation.service';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';

import { DialogComponent } from '../../../components/dialog/dialog.component';
import { FormLabelComponent } from '../../../components/form/label/label.component';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';

import { FormMessageComponent } from '../../../components/form/message/message.component';

import { ProductModel, ProductCategoryModel, ProductCashSale } from '../../../models/consultation/cash-sale.model';
import { ProductCategoriesModel } from '../../../models/master-data/product-categories.model';
import { Observable } from 'rxjs/Observable';
import { Http } from '@angular/http';
import { ProductService } from './product-popup.service';

@Component({
    selector: 'add-product-popup',
    templateUrl: 'product-popup.component.html',
    providers: [ProductService],
    styles: [`
        md-spinner {
            width: 24px;
            height: 24px;
            margin: 5px 10px 0px 0px;
            top: 0;
            right: 0;
            position: absolute;
        }
    `]
})
export class ProductPopupComponent implements OnInit {
    // public isAssignSuccess = false;
    createGroupForm: FormGroup;
    proCategoryList: ProductCategoryModel[];
    proList: ProductModel[];
    searchKey: string;
    filteredProduct: ProductModel[];
    productCashSale = new ProductCashSale();
    isSearching = false;
    isSuccess = false;
    constructor(
        public utility: Utility,
        public baseService: BaseService,
        public dialogService: DialogService,
        private formBuilder: FormBuilder,
        public dialogRef: MdDialogRef<ProductPopupComponent>,
        public productService: ProductService,
        @Inject(MD_DIALOG_DATA) public data: {
            invoiceId: string,
            consultationId: any
        }
    ) { }

    ngOnInit() {
        this.createForm();
        this.createGroupForm.controls['searchProduct'].valueChanges.subscribe(keyword => {
            // filter products list by selected product name
            if (this.isSearching) { return; }
            this.isSearching = true;
            if (keyword) {
                if (keyword.length >= 3) {
                    this.productService.searchProductName(keyword).subscribe(
                        (result) => {
                            this.isSearching = false;
                            const data = result.json();
                            this.filteredProduct = data;
                        }
                    );
                } else {
                    this.isSearching = false;
                    this.filteredProduct = new Array<ProductModel>();
                }
            } else {
                this.isSearching = false;
                this.filteredProduct = new Array<ProductModel>();
            }

        });

        this.createGroupForm.controls['quantity'].valueChanges.subscribe(number => {
            if (number === null) { return; }
            if (number > 999) {
                this.createGroupForm.controls['quantity'].setValue(999);
            }
            if (number < 1) {
                this.createGroupForm.controls['quantity'].setValue(1);
            }
        });

        this.createGroupForm.controls['productCategory'].valueChanges.subscribe(category => {
            if (category === null) { return; }
            if (typeof category === 'object') {

                this.productService.getProductsById(category.id).subscribe(
                    (result) => {
                        if (result) {
                            const data = result.json();
                            this.proList = data;
                        }
                    }
                );
                this.createGroupForm.controls['product'].setValue(new ProductCashSale().product);
                this.searchKey = null;
            } else {
                this.createGroupForm.controls['productCategory'].setValue(new ProductCashSale().category);
            }
        });

        this.createGroupForm.controls['product'].valueChanges.subscribe(product => {
            if (product === null) { return; }
            if (typeof product !== 'object') {
                this.createGroupForm.controls['product'].setValue(new ProductCashSale().product);
            }
        });

        this.productService.getAllProductCategories().subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.proCategoryList = data['list'];
                }
            }
        );
    }

    onSelectedSearchProduct(event: MdOptionSelectionChange, product: ProductModel) {
        if (product) {
            this.createGroupForm.controls['productCategory'].setValue(
                this.proCategoryList.find(proCate => proCate.id === product.productCategoryId)
            );
            this.productService.getProductsById(product.productCategoryId).subscribe(
                (result) => {
                    if (result) {
                        this.proList = result.json();
                        this.createGroupForm.controls['product'].setValue(
                            this.proList ? this.proList.find(pro => pro.id === product.id) : null
                        );
                        event.source.value = null;
                    }
                }
            );

        }
    }

    createForm() {
        this.createGroupForm = this.formBuilder.group({
            searchProduct: [this.searchKey],
            productCategory: [this.productCashSale.category, [Validators.required]],
            product: [this.productCashSale.product, [Validators.required]],
            quantity: [this.productCashSale.quantity, [Validators.required, ValidationService.isValidNumber1To999]]
        });
    }

    onSubmit() {
        if (this.createGroupForm.dirty && this.createGroupForm.valid) {
            const product = this.productCashSale.product;
            product.quantity = this.productCashSale.quantity;
            this.productService.saveProduct(product, this.data.consultationId, this.data.invoiceId).subscribe(result => {
                if (result) {
                    const data = result.json();
                    this.isSuccess = true;
                    this.dialogRef.close(data);
                    /*  this.dialogService.openSuccessDialog({
                         message: data.message
                     });  */
                }
            });
        }
    }

    public onCloseDialog() {
        this.dialogRef.close(this.isSuccess);
    }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/cash-sale/product-popup.component.ts